import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-show-more-popup',
  templateUrl: './show-more-popup.component.html',
  styleUrls: ['./show-more-popup.component.scss']
})
export class ShowMorePopupComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public readonly data: { data: string[], title: string },
    private readonly dialogRef: MatDialogRef<ShowMorePopupComponent>,
  ) { }
  ngOnInit(): void { }

}
